export default "__VITE_ASSET__2b105c76__"